import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ES_HOME_PATH } from "../routes";

const DISMISS_KEY = "es_banner_dismissed";

/**
 * Shown on the English homepage when the visitor's browser prefers Spanish.
 * Makes it easy to find the Spanish site without using a translator.
 */
export default function SpanishLanguageBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(DISMISS_KEY)) return;
    const lang = (navigator.language || navigator.userLanguage || "").toLowerCase();
    if (lang.startsWith("es")) {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  return (
    <div className="bg-[#26A94A] text-white text-center py-3 px-4 text-sm md:text-base relative z-50">
      <span>¿Prefieres español? </span>
      <Link
        to={ES_HOME_PATH}
        className="font-bold underline hover:text-[#EAFB55] transition-colors"
        onClick={() => localStorage.setItem(DISMISS_KEY, "1")}
      >
        Ver el sitio en español
      </Link>
      <button
        type="button"
        onClick={() => {
          localStorage.setItem(DISMISS_KEY, "1");
          setVisible(false);
        }}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-white/80 hover:text-white text-lg leading-none cursor-pointer"
        aria-label="Cerrar"
      >
        ×
      </button>
    </div>
  );
}
